export const AMAZON_STORES = [
  { id: "com", label: "United States", domain: "amazon.com" },
  { id: "co.uk", label: "United Kingdom", domain: "amazon.co.uk" },
  { id: "ca", label: "Canada", domain: "amazon.ca" },
  { id: "de", label: "Germany", domain: "amazon.de" },
  { id: "fr", label: "France", domain: "amazon.fr" },
  { id: "it", label: "Italy", domain: "amazon.it" },
  { id: "es", label: "Spain", domain: "amazon.es" },
  { id: "com.au", label: "Australia", domain: "amazon.com.au" },
  { id: "co.jp", label: "Japan", domain: "amazon.co.jp" },
  { id: "in", label: "India", domain: "amazon.in" },
  { id: "com.mx", label: "Mexico", domain: "amazon.com.mx" },
  { id: "com.br", label: "Brazil", domain: "amazon.com.br" },
];

let store = "com";
export const setAmazonStore = (id) => { store = AMAZON_STORES.some((s) => s.id === id) ? id : "com"; };

export const SEARCH_SITES = [
  { id: "youtube", label: "YouTube", url: (q) => `https://www.youtube.com/results?search_query=${q}` },
  { id: "spotify", label: "Spotify", url: (q) => `https://open.spotify.com/search/${q}` },
  { id: "apple", label: "Apple Music", url: (q) => `https://music.apple.com/us/search?term=${q}` },
  { id: "amazon", label: "Amazon Music", url: (q) => `https://music.amazon.${store}/search/${q}` },
  { id: "bandcamp", label: "Bandcamp", url: (q) => `https://bandcamp.com/search?q=${q}` },
  { id: "discogs", label: "Discogs", url: (q) => `https://www.discogs.com/search/?q=${q}&type=all` },
];

export const searchQuery = (title, artist) => encodeURIComponent(`${artist} ${title}`.trim());

export const amazonBuyUrl = (q) => `https://www.amazon.${store}/s?k=${q}&i=digital-music`;
